import useUser from '@/hooks/useUser';
import { useNarrative } from './hooks/useNarrative';
import { PublicNarrativeEdit } from './components/PublicNarrativeEdit';
import { NarrativeLayout } from './NarrativeLayout';
import { useMount } from '@simplywallst/ui-core';
import { useParams } from '@/hooks/location/useParams';
import { NarrativeNotFound } from './components/NarrativeNotFound';
import { useFlag } from '@simplywallst/unleash';
import { useNarrativeCompany } from './hooks/useNarrativeCompany';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';

export const PublicNarrativeEditPage = () => {
  const {
    enabled: updateNarrativeUpdateEnabled,
    ready: updateNarrativeUpdateReady,
  } = useFlag('narrative-content-from-updates');

  const isUpdateNarrativeUpdateEnabled =
    updateNarrativeUpdateEnabled && updateNarrativeUpdateReady;

  const { id: narrativeId } = useParams<{ id: string }>();
  const { getItem } = useQueryStringParam();
  const { data: user } = useUser();
  const { data: narrativeResponse, status: useNarrativeStatus } = useNarrative(
    { slug: narrativeId },
    {
      enabled: isUpdateNarrativeUpdateEnabled
        ? false
        : Boolean(narrativeId && user.loggedIn),
    }
  );

  const { data: narrativeCompany, status: useNarrativeCompanyStatus } =
    useNarrativeCompany(
      {
        companyId: getItem('company')?.toLowerCase() ?? '',
      },
      {
        enabled: isUpdateNarrativeUpdateEnabled,
      }
    );

  const isLoading = isUpdateNarrativeUpdateEnabled
    ? useNarrativeCompanyStatus === 'pending'
    : useNarrativeStatus === 'pending';

  const isError = isUpdateNarrativeUpdateEnabled
    ? useNarrativeStatus === 'error'
    : useNarrativeCompanyStatus === 'error';

  useMount(() => window.scrollTo(0, 0));

  if (!user.loggedIn) {
    return <NarrativeNotFound />;
  }

  const narrative = narrativeResponse?.narrative;

  return (
    <NarrativeLayout
      title="Edit Narrative"
      isLoading={isLoading}
      error={isError}
    >
      {narrative && <PublicNarrativeEdit narrative={narrative} />}
      {!narrative && narrativeCompany?.Company?.myNarrative && (
        <PublicNarrativeEdit myNarrativeCompany={narrativeCompany?.Company} />
      )}
    </NarrativeLayout>
  );
};
